import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogExclusiveComponent } from './dialogExclusive.component';
import { SharedModule } from '@/shared/shared.module';

@NgModule({
  declarations: [DialogExclusiveComponent],
  imports: [CommonModule, SharedModule],
})
export class DialogExclusiveModule {

}
